<template>
  <div :class="['field-custom', {'no-mb':noMB}]" :id="uniqID">
    <form data-vv-scope="mobile-form" class="mobile-form" v-if="renderForm">
      <div :class="{'intl-tel-input allow-dropdown margin-b-xs':true, 'field-error': errors.has('mobile-form.mobile') || hasError, 'disabled': showVericationForm, [dialCodeLength]:true, 'no-mb':noMB}">

        <div class="flag-container" >
          <div class="selected-flag padding-a-s" @click="showSubMenu" :title="currentData.name + ': +' + currentData.dialCode">
            <div :class="'iti-flag ' + currentData.code"></div>
            <div class="iti-arrow"></div>
          </div>
          <div class="country-list-wrap">
            <ul class="country-list" v-show="!hideSubMenu">
              <li class="country-search">
                <input type="text" ref="inputMobileSearch" v-focus="!hideSubMenu" v-model="inputMobileSearch" />
              </li>
              <li class="search-space"></li>
              <li class="divider"></li>
              <li @click="currentCode = item.code;hideSubMenu = true;updateMobile()" v-for="item in frontCountriesArray" :class="'country ' + (item.code == currentCode ? 'highlight' : '')" v-show="isSearching">
                <div class="flag-box">
                  <div :class="'iti-flag ' + item.code"></div>
                </div>
                <span class="country-name">{{ item.name }}</span>
                <span class="dial-code">+{{ item.dialCode }}</span>
              </li>
              <li class="divider"></li>
              <li @click="currentCode = item.code;hideSubMenu = true;updateMobile()" v-for="item in countriesArray" :class="'country ' + (item.code == currentCode ? 'highlight' : '')" v-show="countryFilter(item.name)">
                <div class="flag-box">
                  <div :class="'iti-flag ' + item.code"></div>
                </div>
                <span class="country-name">{{ cleanCountryName(item.name) }}</span>
                <span class="dial-code">+{{ item.dialCode }}</span>
              </li>
            </ul>
          </div>
        </div>

        <span class="dial-code-label">+{{ currentData.dialCode }}</span>
        <input type="mobile" name="mobile" :class="['form-control 1', {'disabled': disableField}]" :disabled="disableField" v-model="inputMobile" v-validate="'required|numeric'" data-vv-validate-on="none" @change="updateMobile" v-if="required" v-on:keypress="isNumber">
        <input type="mobile" name="mobile" :class="['form-control 2', {'disabled': disableField}]" :disabled="disableField" v-model="inputMobile" v-validate="'numeric'" data-vv-validate-on="none" @change="updateMobile" v-if="!required" v-on:keypress="isNumber">
        <span v-show="false">{{inputMobile}}-{{showVericationForm}}-{{resendReady}}</span>


        <div :class="{'field-button text-center':true, 'verified': mobileIsVerified, 'disabled': (errors.any('mobile-form') || this.inputMobile === '' || showVericationForm || !resendReady)}" v-if="needVerification">
          <div v-if="!getPinLoading" class='field-button-ie'>
            <a href="javascript:;" v-on:click="showHideForm" v-if="!mobileIsVerified">
              {{ $t('global.verify') }}
              <icon name="chevron-down" v-if="!showVericationForm"></icon>
              <icon name="chevron-up" v-if="showVericationForm"></icon>
            </a>
            <a href="javascript:;" v-if="mobileIsVerified">
              {{ $t('global.verified') }}
              <icon name="check" class="verified-icon"></icon>
            </a>
          </div>
          <div v-if="getPinLoading" class='field-button-ie'>
            <a>
              {{ $t('global.loading') }}
              <icon name="refresh" spin class="magin-l-s"></icon>
            </a>
          </div>
        </div>

        <span v-show="errors.has('mobile-form.mobile')" class="field-error-message">{{ errors.first('mobile-form.mobile') }}</span>
      </div>
    </form>

    <div v-if="!disableChangingPhone && needVerification && mobileIsVerified" class="change-num-box">
      <a href="javascript:;" class="change-phone" v-on:click="changePhoneNumber" v-if="mobileIsVerified">{{ $t('global.changePhone') }}</a>
    </div>

    <div :class="['mobile-verify-form showhide-fadeslide', ((showVericationForm && !mobileIsVerified)? '' : 'hide')]" v-if="needVerification">
      <form :class="['padding-a-m', isSafari]" data-vv-scope="verify-form" v-on:submit.prevent="verifyPin()">
        <p class="margin-t-z">{{ $t('global.textPin') }}</p>
        <div class="medium-6 medium-offset-3 cell text-center">
          <div class="field-group margin-b-s">
            <div :class="{'field-combo':true, 'field-error': errors.first('verify-form.pin')}">
              <div class="field-button static left">
                <span class="padding-a-s">{{ $t('global.pin') }}</span>
              </div>
              <input type="text" name="pin" :class="{'field-text':true, 'disabled':pinVerificationLoading}" v-model="inputPin" :disabled="pinVerificationLoading" ref="pin" />
              <div class="field-button right">
                <button class="padding-a-s" type="submit" v-if="!pinVerificationLoading">{{ $t('global.verify') }}</button>
                <button class="padding-a-s" type="button" v-if="pinVerificationLoading">{{ $t('global.loading') }}</button>
              </div>
              <span v-show="errors.first('verify-form.pin')" class="field-error-message">{{ errors.first('verify-form.pin') }}</span>
            </div>
          </div>
          <div class="field-error-message2" v-show="needVerify && !errors.first('verify-form.pin')">{{$t('global.verifyFirst')}}</div>
          <a href="javascript:;" :class="['resend', {disabled: !resendReady}]" v-on:click="resendPin" v-show="!pinVerificationLoading">
            {{ $t('global.resendPin') }}
            <span v-if="resendCountdown > 0">({{ resendCountdown }} secs)</span>
            <icon name="refresh" spin class="magin-l-s" v-if="resendPinLoading"></icon>
          </a>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import VeeValidate from 'vee-validate'
const countries = require('@/data/countries')

Vue.use(VeeValidate)

export default (function () {
  return {
    props: {
      mobile: {
        default () { return []; }
      },
      uniqID: {
        default () { return []; }
      },
      hasError: {
        default () { return []; }
      },
      needVerification: {
        default () { return []; }
      },
      required: {
        default () { return []; }
      },
      toFront: {
        type: Array,
        default () {
          return ['us', 'ca', 'gb'];
        }
      },
      countryCode: {
        type: String,
        default: Object.keys(countries)[225],
        validator (code) {
          var clearCode = String(code).toLowerCase();
          return !!countries[clearCode];
        }
      },
      dialCode: {
        default () {
          return [];
        }
      },
      forPax: {
        default () { return false }
      },
      noMB: {
        default () { return false }
      }
    },
    data () {
      return {
        inputMobile: '',
        inputMobileSearch: null,
        inputPin: '',
        currentCode: this.countryCode,
        currentCodeLength: 0,
        hideSubMenu: true,
        showVericationForm: false,
        getPinLoading: false,
        needMobileVerification: true,
        mobileIsVerified: false,
        pinVerificationLoading: false,
        resendPinLoading: false,
        disableChangingPhone: false,
        dialCodeDefault: '',
        needVerify: false,
        isSafari: (navigator.userAgent.indexOf('Safari') !== -1 &&
          navigator.userAgent.indexOf('Chrome') === -1) ||
          navigator.userAgent.indexOf('Edge') > -1 ? 'safari' : '',
        renderForm: true
      }
    },
    computed: {
      user () { return this.$store.state.user },
      currentBrand () { return this.$store.state.brandCode },
      currentData () {
        this.currentCodeLength = String(countries[this.currentCode].dialCode).length
        return countries[this.currentCode]
      },
      frontCountriesArray () {
        const toFrontCodes = {};

        this.toFront.forEach((code) => {
          const stringCode = String(code);
          const needObj = countries[stringCode];

          if (needObj) {
            toFrontCodes[stringCode] = needObj;
          }
        });

        return toFrontCodes;
      },
      countriesArray () {
        const countryCopie = {...countries};

        this.toFront.forEach((code) => {
          delete countryCopie[code];
        });

        return countryCopie;
      },
      dialCodeLength () {
        let lengthClass = ['', 'small', 'medium', 'large']
        return lengthClass[this.currentCodeLength - 1]
      },
      disableField () {
        if (!this.needVerification) { return false }
        if (this.mobileIsVerified || this.getPinLoading) { return true }
        if (this.showVericationForm) {
          this.needMobileVerification = false
          return true
        }
        // if (this.mobile) {
        //   if (this.mobile) {
        //     this.mobileIsVerified = true
        //     this.$emit('verified', true)
        //   }
        //   return true
        // } else if (!this.needMobileVerification) {
        if (!this.needMobileVerification) {
          return false
        }
        let firstVisit = this.$store.state.user.firstVisit
        if (this.mobile === firstVisit.mobile && this.currentData.dialCode === firstVisit.countryCode && this.mobileIsVerified) return true
        // this.mobileIsVerified = false
      },
      disableVerifyBtn () {
        if (!this.inputMobile) {
          return true
        }
        return false
      },
      mobileValue () {
        this.inputMobile = this.mobile
        return this.mobile
      },
      isSearching () {
        return this.inputMobileSearch === '' || this.inputMobileSearch === null
      },
      isCorporate () { return this.$store.state.user.isCorporate },
      resendReady: {
        get () { return this.$store.state.user.resend.ready },
        set (x) { this.$store.commit('user/setResendReady', x) }
      },
      resendCountdown: {
        get () { return this.$store.state.user.resend.countdown },
        set (x) { this.$store.commit('user/setResendCountdown', x) }
      },
      d2d () { return this.$store.state.reservation.d2d },
      firstVisit () { return this.user.firstVisit }
    },
    methods: {
      showSubMenu: function () {
        if (this.disableField) {
          return false
        }
        this.hideSubMenu = !this.hideSubMenu
        if (this.showVericationForm === true) {
          this.hideSubMenu = true;
        }
      },
      showHideForm: function () {
        if (this.mobile && !this.needMobileVerification || !this.inputMobile || !this.needVerification) { return }
        this.mobileIsVerified = false
        if (!this.showVericationForm) {
          this.getPinLoading = true
          this.errors.remove('mobile-form.mobile')
          this.getPin(countries[this.currentCode].dialCode, true)
          return
        }
        this.showVericationForm = false
      },
      getPin (code, isResend) {
        let self = this
        let countryCode = code.toString()
        if (countryCode.indexOf('+') > -1) {
          countryCode = countryCode.substr(1)
        }
        let expected = (`${self.inputMobile}${countryCode.replaceAll('+', '')}` >> 2) * 5
        self.$sdk.post(self, '/auth/sms/code', {
          phone: self.inputMobile,
          countryCode: code,
          code: expected
        }, response => {
          if (!response.notes) {
            // this.app.$emit('getPinSuccess', event)
            if (!self.needVerification) { return }
            self.getPinLoading = false
            self.resendPinLoading = false
            self.showVericationForm = true
            self.$nextTick(function () {
              if (self.$refs.pin.focus() && !self.pinVerificationLoading) {
                self.$refs.pin.focus()
              }
            })
            if (isResend) {
              self.resendReady = false
            }
          } else {
            // this.app.$emit('getPinFail')
            if (!self.needVerification) { return }
            self.getPinLoading = false
            self.showVericationForm = false
            self.errors.add('mobile-form.mobile', self.$t('global.oops'))
          }
        }, '/1.1')
      },
      updateMobile: function () {
        let _dialCode = countries[this.currentCode].dialCode
        let _mobile = this.inputMobile
        if (_mobile && _mobile.toString().indexOf(_dialCode) === 0) {
          _mobile = _mobile.substring(_dialCode)
        }
        this.$emit('updateMobile', {
          mobile: _mobile,
          countryCode: _dialCode
        })
        if (!this.forPax) {
          this.$store.commit('user/setUserPhone', {
            number: _mobile,
            code: _dialCode
          })
        }

        // if (CONFIG.Env == 'production' && window.gtag) { // eslint-disable-line
        //   gtag('event', 'Mobile Number', { // eslint-disable-line
        //     value: `${_dialCode}${_mobile}`
        //   })
        // }
      },
      changePhoneNumber: function () {
        this.needMobileVerification = true
        this.mobileIsVerified = false
        this.showVericationForm = false
        this.getPinLoading = false
        this.inputPin = ''
        this.errors.remove('verify-form.pin')
        this.$emit('verified', false)

        let self = this
        self.renderForm = false
        setTimeout(function () {
          self.renderForm = true
        }, 100)
      },
      getCountryCodeByDialCode: function (val) {
        let keySelected = 'us'
        Object.keys(countries).map(function (key) {
          if (countries[key].dialCode === Number(val)) {
            keySelected = key
          }
        });
        return keySelected
      },
      countryFilter: function (val) {
        let countryName = val.toLowerCase()
        let regex = new RegExp(this.inputMobileSearch, 'gi')
        if (countryName.match(regex) || this.inputMobileSearch === null || this.inputMobileSearch === '') {
          return true
        } else {
          return false
        }
      },
      verifyPin: function () {
        let self = this
        if (self.getPinLoading) { return }
        self.needVerify = false
        self.errors.remove('verify-form.pin')
        if (self.inputPin.trim() === '') {
          self.errors.add('verify-form.pin', self.$t('global.fieldRequired'))
          return
        }
        self.$validator.validateAll('verify-form').then(result => {
          if (result) {
            self.pinVerificationLoading = true
            self.$sdk.post(self, '/auth/sms/verify', {
              phone: self.inputMobile,
              countryCode: countries[self.currentCode].dialCode,
              smsCode: self.inputPin
            }, res => {
              if (res.error) {
                // this.app.$emit('mobileVerifyFail')
                if (!self.needVerification) { return }
                self.pinVerificationLoading = false
                self.errors.add('verify-form.pin', self.$t('global.invalidPin'));
                self.$emit('verified', false)
              } else {
                // this.app.$emit('mobileVerifySuccess')
                if (!self.needVerification) { return }
                self.$emit('verified', true)
                self.showVericationForm = false
                self.mobileIsVerified = true
                self.pinVerificationLoading = false
                self.disableChangingPhone = false
                self.resendReady = false
              }
            })
          }
        })
      },
      triggerValidate: function () {
        if (this.isCorporate && this.required) {
          this.$validator.validateAll('mobile-form').then(result => {
            if (result) {
              // this.$emit('guestMobileValidate', true)
            } else {
              // this.$emit('guestMobileValidate', false)
            }
          })
        }

        if (this.mobileIsVerified || !this.needVerification) {
          return
        }
        if (this.showVericationForm) {
          this.needVerify = true
          this.$emit('verified', false)
          this.$validator.validateAll('verify-form').then(result => {
          })
        } else {
          this.errors.add('mobile-form.mobile', this.$t('global.verifyFirst'));
        }
      },
      resendPin: function () {
        if (!this.resendReady) { return }
        this.inputPin = ''
        this.errors.remove('verify-form.pin')
        this.resendPinLoading = true
        this.getPin(countries[this.currentCode].dialCode, true)
      },
      reset: function () {
        this.mobileIsVerified = false
        var self = this
        setTimeout(function () {
          self.errors.items = []
        }, 50)
      },
      isNumber (evt) {
        let charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
          evt.preventDefault()
          return
        }
        return true
      },
      cleanCountryName (val) {
        let val2 = val.slice(0, val.indexOf(" ("))
        return val.indexOf(" (") === -1 ? val : val2
      },
      recheckVerification: function () {
        if (this.mobile === this.firstVisit.mobile && this.currentData.dialCode === this.firstVisit.countryCode && this.firstVisit.mobile) this.mobileIsVerified = true
      },
      alreadyVerified () {
        this.mobileIsVerified = true
      }
    },
    watch: {
      mobile: function (val) {
        this.inputMobile = val
      },
      dialCodeDefault: function (val) {
        this.currentCode = val
        // this.disableChangingPhone = true
      },
      dialCode: function (val) {
        if (val && this.dialCode) {
          this.currentCode = this.getCountryCodeByDialCode(val)
          // this.disableChangingPhone = true
        }
      }
    },
    mounted () {
      let self = this
      let userPhone = this.$store.state.user.phone

      if (this.dialCode) {
        this.dialCodeDefault = this.getCountryCodeByDialCode(this.dialCode)
      } else if (this.$store.state.user.phone.code) {
        this.dialCodeDefault = this.$store.state.user.phone.code
      }

      this.inputMobile = this.mobile
      if (userPhone.number && this.required) {
        if (!this.d2d.travellers.forSomeoneElse) {
          this.inputMobile = userPhone.number
        }
        this.dialCodeDefault = this.getCountryCodeByDialCode(userPhone.code)
      } else if (!this.required) {
        let guestInfo = this.$store.state.guestInfo
        this.inputMobile = guestInfo.mobile
        this.dialCodeDefault = this.getCountryCodeByDialCode(guestInfo.countryCode)
      }

      window.addEventListener("click", (evt) => {
        if (!self.hideSubMenu) {
          let flyoutEl = document.getElementById(self.uniqID)
          let targetEl = evt.target // clicked element
          do {
            if (targetEl === flyoutEl) {
              return
            }
            targetEl = targetEl.parentNode
          } while (targetEl)
          self.hideSubMenu = true
        }
      })
    }
  };
}());
</script>

<style lang="scss" scoped>
@import "../../assets/vendor/intlTelInput/css/intlTelInput.css";
@import "../../assets/scss/MobileInput.scss";

.field-custom{
  margin-bottom: 10px;
}

a.resend {
  &.disabled{
    cursor: default;
    color: #777!important;
  }
  span{
    display: inline-block;
    margin-left: 3px;
  }
}
.field-error-message2{
  font-size: 12px;
  background-color: #eb5837;
  color: #fff;
  padding: 3px 10px 5px;
  margin: 0;
  float: right;
}
.change-num-box{
  text-align: right;
}
.field-error{
  margin-bottom: 0!important;
}
.form-control{
  background: #fff!important;
}
.no-mb{
  margin-bottom:0!important;
}
</style>



// WEBPACK FOOTER //
// MobileInput.vue?492d3af0